/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceIdWithFeatureList { 
    features?: Array<DeviceIdWithFeatureList.FeaturesEnum>;
    idDevice?: number;
}
export namespace DeviceIdWithFeatureList {
    export const FeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type FeaturesEnum = typeof FeaturesEnum[keyof typeof FeaturesEnum];
}


export type FeaturesEnum = typeof DeviceIdWithFeatureList.FeaturesEnum[keyof typeof DeviceIdWithFeatureList.FeaturesEnum];
